module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURfyKNPyKNEdwTPuJM/yKM/yKNfmLMfyKNPyKMv+JKPmMNPyKNP6OMvyKNSCbmcAAAAAOdFJOU2bMADSZvxmwUg0miRtzmqoAYgAAANNJREFUKM9jUEIDDFgEDBjggGMSUEBBEAlUAgUMRd0RAhJAAcYyZTQBJ2s4X5QJLLARLiCsBBZIgFnCCBWAu0ERt8AyJSWFSiQBXdFJSoxhSALagpMURBchCagxKzFGoRoKVoAsAFaAJABUoCKBLABUkCiNJAAyQbcKSUAjiqDTQUDNCC6gWQ5yhKnsJJiAtmCwEiisi2ECF30FmzQ3CpgLXoQIOAgoMQqkixqpFUKDULQJqD6wTElpNlSgDGSiyCSQj8ACJ0BMnSaQzRpN2CMbFQAAf31K0xcYimwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/discountIcon@2x.png
// module id = 1780
// module chunks = 0